module.exports = __webpack_public_path__ + "img/team6.eab17f42.png";